module.exports = __webpack_public_path__ + "static/media/hero-4.f8b63600.jpg";